export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "confirm-button-label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmer"])},
        "cancel-button-label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Annuler"])}
      },
      "en": {
        "confirm-button-label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirm"])},
        "cancel-button-label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancel"])}
      }
    }
  })
}
